import React from 'react';

import { carrotQuest } from '../helpers';

export const useCarrotQuestScript = (
  carrotQuestInstance?: ReturnType<typeof carrotQuest>,
) => {
  const [isScriptReady, setIsScriptReady] = React.useState(false);

  React.useEffect(() => {
    if (!carrotQuestInstance) {
    	return;
    }

    const scriptElement = carrotQuestInstance.script();
    if (scriptElement) {
      document.head.append(scriptElement);
      setIsScriptReady(true);
    }
  }, [carrotQuestInstance]);

  return isScriptReady;
};
